
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/[companySlug]",
      function () {
        return require("private-next-pages/company/[companySlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/[companySlug]"])
      });
    }
  